/**
 * Created by oleg on 11/29/16.
 */
import React from 'react';

const FormDelimiter = () => (<hr className="pull-left full-width" />);

export default FormDelimiter;
